$(document).ready(function() {
  let removeOpenTimeout;
  
  // Variables para detectar scroll vs tap
  let touchStartY = 0;
  let touchStartX = 0;
  let isScrolling = false;

  // Registrar inicio de toque para rastrear desplazamiento
  $(document).on('touchstart', function(e) {
    const touch = e.originalEvent.touches[0];
    touchStartY = touch.clientY;
    touchStartX = touch.clientX;
    isScrolling = false;
  });

  $(document).on('touchmove', function(e) {
    const touch = e.originalEvent.touches[0];
    const deltaY = Math.abs(touch.clientY - touchStartY);
    const deltaX = Math.abs(touch.clientX - touchStartX);

    // Si el dedo se movió más de 10px, se considera SCROLL
    if (deltaY > 10 || deltaX > 10) {
      isScrolling = true;
    }
  });

  // Helper unificado de eventos de clic/tap que respeta el scroll
  function handleTap(e, callback) {
    if (isScrolling) {
      return false; // Ignorar si el usuario estaba haciendo scroll
    }
    
    e.stopPropagation();
    e.stopImmediatePropagation();
    callback();
  }

  // Company Menu (Epic sections) - Desktop hover functionality
  function setupCompanyMenu() {
    const $companyTitle = $('.content-company-menu-title');
    const $companyContainer = $('.content-company-menu-container');

    function closeCompanyMenu() {
      removeOpenTimeout = setTimeout(() => {
        $companyTitle.parent().removeClass("open");
        $companyContainer.removeClass("open");
      }, 1);
    }

    function cancelClose() {
      clearTimeout(removeOpenTimeout);
    }

    $companyTitle.on('mouseenter', function() {
      cancelClose();
      $(this).parent().addClass("open");
      $companyContainer.addClass("open");
      $(".content-company-menu .nav-section").removeClass("active");
    });

    $companyTitle.on('mouseleave', closeCompanyMenu);
    $companyContainer.on('mouseenter', cancelClose);
    $companyContainer.on('mouseleave', closeCompanyMenu);

    $companyContainer.find('.nav-section').on('mouseenter', function() {
      $companyContainer.find('.nav-section').removeClass("active");
      $(this).addClass("active");
    });
  }

  // Mobile Menu functionality
  function setupMobileMenu() {
    // Toggle main mobile menu
    $('.not-hover-supported .content-menu-mobile').off('touchend click').on('touchend click', function(e) {
      if (e.type === 'touchend' && isScrolling) return;
      if (e.type === 'touchend') e.preventDefault();

      $("header").toggleClass("menu-mobile-opened");
      resetMobileMenuState();
    });

    // Nivel 1 -> Nivel 2 (Ej: FOR THE BIKE, COMMUNITY)
    $(document).off('touchend click', '.not-hover-supported .nav-section-title').on('touchend click', '.not-hover-supported .nav-section-title', function(e) {
      if (e.type === 'touchend' && isScrolling) return;

      handleTap(e, () => {
        const $title = $(this).closest('.nav-section-title');
        const $section = $title.closest(".nav-section");
        const $category = $section.find(".nav-category");
        
        // CASO A: Tiene submenú desplegable
        if ($category.length > 0) {
          e.preventDefault();
          
          if (document.activeElement) {
            document.activeElement.blur();
          }

          $('.nav-section').not($section).removeClass('active').addClass('hidden').attr('aria-expanded', 'false');
          $('.row.nav .content-store').addClass('hidden');

          $title.addClass("hidden").attr('style', 'display: none !important;');
          $section.removeClass("hidden").addClass("active").attr('aria-expanded', 'true');
          
          $category.addClass("open active").attr('style', 'display: flex !important;');
          $('.nav-category-title').removeClass('hidden').removeAttr('style');

          $('.content-back-menu p').text('Back to Menu');
          $('.content-back-menu').removeClass('hidden').show();
          return;
        }

        // CASO B: Enlace directo
        const $anchor = $title.find('a').length ? $title.find('a') : $title.closest('a');
        const href = $anchor.attr('href');
        if (href && href !== '#' && !href.startsWith('javascript:')) {
          window.location.href = href;
        }
      });
    });

    // Nivel 2 -> Nivel 3 (Ej: ROAD, MOUNTAIN, o Links de Epic Sections)
    $(document).off('touchend click', '.not-hover-supported .nav-category-title').on('touchend click', '.not-hover-supported .nav-category-title', function(e) {
      if (e.type === 'touchend' && isScrolling) return;

      handleTap(e, () => {
        const $this = $(this);
        const isAnchor = $this.is('a');
        const href = $this.attr('href');
        const $subcategory = $this.siblings('.nav-subcategory');

        // CASO A: Desplegable con subcategorías
        if ($subcategory.length > 0) {
          e.preventDefault();

          if (document.activeElement) {
            document.activeElement.blur();
          }

          $('.nav-category-title').addClass('hidden').attr('style', 'display: none !important;');
          $('.nav-category-view-all-mobile').addClass('hidden').attr('style', 'display: none !important;');
          
          $('.nav-subcategory').not($subcategory).removeClass('open').attr('style', 'display: none !important;');
          $subcategory.removeClass('hidden').addClass('open').attr('style', 'display: block !important;');

          $('.content-back-menu p').text(`Back to Menu`);
          $('.content-back-menu').removeClass('hidden').show();
          return;
        }

        // CASO B: Enlace directo <a>
        if (isAnchor && href && href !== '#' && !href.startsWith('javascript:')) {
          window.location.href = href;
        }
      });
    });

    // Switcher Shop / Epic Sections
    $('header .content-labels .label').off('touchend click').on('touchend click', function(e) {
      if (e.type === 'touchend' && isScrolling) return;

      handleTap(e, () => {
        const label = $(this).data("label");
        
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        
        $(".label-menu").removeClass("active");
        $(`.label-menu[data-label='${label}']`).addClass("active");
        
        if (label === "shop") {
          $("header .content-store").removeClass("hidden");
        } else {
          $("header .content-store").addClass("hidden");
        }
        
        resetMobileMenuState();
      });
    });

    // Columnas secundarias
    $('.not-hover-supported .category-title').off('touchend click').on('touchend click', function(e) {
      if (e.type === 'touchend' && isScrolling) return;

      handleTap(e, () => {
        const $category = $(this).parents(".category");
        const $column = $(this).parents(".content-categories-column");
        
        $category.addClass("active");
        $(".content-categories-column").addClass("hidden");
        $column.removeClass("hidden");
      });
    });
  }

  // Helper para reseteo completo
  function resetMobileMenuState() {
    if ($('.not-hover-supported').length) {
      const elementsToShow = [
        ".nav-section", ".row.nav .content-store", ".nav-section-title", 
        ".nav-category-title", ".nav-category-view-all-mobile"
      ];
      showElements(elementsToShow);
      
      $('.nav-section-title').removeClass('hidden').removeAttr('style');
      $('.nav-section').removeClass('active hidden').attr('aria-expanded', 'false');
      $('.nav-category').removeClass('open active').removeAttr('style');
      $('.nav-subcategory').removeClass('open').removeAttr('style');
      $('.content-back-menu').addClass('hidden');
    }
  }

  function hideElements(selectors) {
    selectors.forEach(selector => $(selector).addClass("hidden"));
  }

  function showElements(selectors) {
    selectors.forEach(selector => $(selector).removeClass("hidden"));
  }

  // Initialize
  setupCompanyMenu();
  setupMobileMenu();
});

// Back to menu functionality
$(document).off('touchend click', '.content-back-menu, .content-back-menu-icon, .content-back-menu-text').on('touchend click', '.content-back-menu, .content-back-menu-icon, .content-back-menu-text', function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  
  const $content_back_menu = $('.content-back-menu');
  const $content_back_menu_p = $('.content-back-menu p');
  
  const $openSubcategory = $('.nav-subcategory.open');
  const $openCategory = $('.nav-category.open');
  
  // 1. Regresar de Nivel 3 a Nivel 2
  if ($openSubcategory.length > 0) {
    $openSubcategory.removeClass('open').removeAttr('style');
    $('.nav-category-title').removeClass('hidden').removeAttr('style');
    $('.nav-category-view-all-mobile').removeClass('hidden').removeAttr('style');
    
    $content_back_menu_p.text(`Back to Menu`);
    $content_back_menu.removeClass('hidden');
    return false;
  }
  
  // 2. Regresar de Nivel 2 a Nivel 1
  if ($openCategory.length > 0) {
    $openCategory.removeClass('open active').removeAttr('style');
    
    const $section = $openCategory.parents('.nav-section');
    $section.find('.nav-section-title').removeClass('hidden').removeAttr('style');
    $section.attr('aria-expanded', 'false').removeClass('active');
    
    $('.nav-section').removeClass('hidden active').attr('aria-expanded', 'false');
    $('.nav-section-title').removeClass('hidden').removeAttr('style');
    $('.row.nav .content-store').removeClass('hidden');
    
    $content_back_menu.addClass('hidden');
    return false;
  }
});